import React from 'react'
import { NavLink } from 'react-router-dom'
import { Page } from '../../../../shared/UI'
import { useMoneyBox } from '../../../../services/api/MoneyBox'
import { Routes } from '../../../../shared/enum'

export const Winners = () => {
  const { boxId } = useMoneyBox()

  return <Page
    variant="root"
    title="Победители в копилке"
    col={[
      { id: 'id', label: 'ID', render: (id) => <NavLink to={`/${Routes.USER}/${id}`}>{id}</NavLink> },
      { id: 'phone', label: 'Телефон' },
      { id: 'social.email', label: 'Почта' },
      { id: 'login', label: 'Логин' },
    ]}
    rows={boxId.winners.data?.items}
    total={boxId.winners.data?.metadata.total}
    onChange={boxId.winners.fetch}
    filter={[
      {
        label: 'Фильтры',
        defaultExpanded: true,
        fields: [
          { name: 'id', type: 'number', label: 'Копилка ID' },
          { name: 'userId', type: 'number', label: 'Юзер ID' },
        ],
      },
    ]}
  />
}
